module.exports = __webpack_public_path__ + "img/01b407144546f428a9a95dc4bf42ccfb.png";